/*
 * @Description: common client methods
 * @Author: Rfan
 * @Date: 2020-06-11 14:29:50
 * @LastEditTime: 2024-01-24 11:11:42
 */
/**
 * @module client/index 
 */

/** 
 * 调取客户端方法
 * @fileoverview 调取客户端方法
 * @author Rfan
 */

import { testPlatform } from "@/utils";
/**
 * @typedef {Object} userInfo
 * @property {number} userId - userId
 * @property {string} token token
 * @property {string} nick 姓名
 * @property {string} avatar 头像
 */


export function receiveGetInfo() {
  console.log('receive');
  window.hsj.getUserInfo();
  window.hsj.getVerInfo();
}

/**
 * @description 获取会员信息
 * @function
 * @returns {userInfo} 会员信息
 * @see {@link userInfo}
 */

export function getUserInfo() {
  return window.hsj.getUserInfo();
}

/**
 * @typedef {Object} verInfo
 * @property {number} verCode 版本号
 * @property {string} verName 版本名字
 */
/**
 * 安卓获取软件版本信息
 * @returns {verInfo} 软件版本信息
 */
export function getAppVerInfo() {
  return window.hsj.getVerInfo();
}

/**
 * 客户端主动调取——用户信息回调
 * @param {string} data JSON
 */
export function getUserInfoSuccess(data) {
  console.log('getUserInfoSuccess: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].userInfoCb) {
    vueNode.$children[0].userInfoCb(data)
  } else {
    vueNode.userInfoCb(data)
  }
}

/**
 * 客户端主动调取——用户登录成功回调
 * @param {string} data JSON
 */
export function loginSuccess(data) {
  console.log('loginSuccess: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].loginSuccess) {
    vueNode.$children[0].loginSuccess(data)
  } else {
    vueNode.loginSuccess(data)
  }
}

/**
 * 客户端主动调取——用户下载模版并打开回调
 * @param {string} data JSON
 */
 export function templateInstallAndOpenCallBack(data) {
  console.log('templateInstallAndOpenCallBack: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].templateInstallAndOpenCallBack) {
    vueNode.$children[0].templateInstallAndOpenCallBack(data)
  } else {
    vueNode.templateInstallAndOpenCallBack(data)
  }
}

/**
 * 客户端主动调取——软件版本信息回调
 * @param {string} data JSON
 */
export function getAppVerInfoSuccess(data) {
  console.log('getAppVerInfoSuccess: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].versionCb) {
    vueNode.$children[0].versionCb(data)
    
  } else {
    vueNode.versionCb(data)
  }
}

/**
 * 打开客户端个人中心
 * @param {Number} id 
 * @return: 
 */
export function gotoUserCenter(id) {
  if (testPlatform("ios")) {
    console.log("user ios ", id);
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("gotoUserCenter", id, function () { });
    });
  } else {
    console.log("user android ", id);
    window.hsj.gotoUserCenter(id);
  }
}



/*  ------  🍎 ios  ------  */
/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iosCallback
 * @param {any} func 需要执行的方法
 */

/**
 * 🍎ios客户端方法
 * @param {iosCallback} callback - The callback that handles the response.
 */
export function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

/**
 *  转移页面客户端返回用户信息滞后时主动调取方法
 */
export function getBindInfo() {
  const vueNode = app.__vue__;
  console.log('router name', vueNode.$route.name);
  if (vueNode.$route.name && vueNode.$route.name === 'activatevipIndex') {
    console.log('bind node', vueNode.$children[0].$children[0]);
    vueNode.$children[0].$children[0].getVipInfo();
  }
  if (vueNode.$route.name && vueNode.$route.name === 'Christmas2023') {
    console.log('bind node', vueNode.$children[0]);
    vueNode.$children[0].updatedUserInfo();
  }
  if (vueNode.$route.name && vueNode.$route.name === 'SpringFestival2024') {
    console.log('bind node', vueNode.$children[0]);
    vueNode.$children[0].updatedUserInfo();
  }
}
